<template>
  <div class="bar-container" ref="barChart" :style="{ height: this.chartHeight + 'px' }">
    <div class="column" v-for="data in bloodData" :key="data.type">
      <div class="bar" :style="{ height: data.barHeight + 'px' }">
      </div>
      <div class="bar-label">
        {{ data.type }}<br/>
        <span>{{ data.units }} {{ unitLabel }} </span>
      </div>
    </div>
    <div class="chart-axis"></div>
  </div>
</template>

<script>
export default {
  name: 'BarChart',
  props: ['bloodData', 'chartHeight', 'unitLabel'],
  mounted () {
    this.updateBarHeight()
  },
  updated () {
    this.updateBarHeight()
  },
  methods: {
    updateBarHeight () {
      var maxBarHeight = this.$refs.barChart.clientHeight - 60
      var maxUnits = Math.max.apply(Math, this.bloodData.map((o) => (o.units)))
      for (let index in this.bloodData) {
        this.bloodData[index].barHeight = (this.bloodData[index].units / maxUnits) * maxBarHeight
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bar-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
  position: relative;
  .chart-axis {
    bottom: 60px;
    width: 100%;
    height: 1px;
    background-color: $gray-500;
    position: absolute;
  }
}
.column {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 70px;
  .bar {
    width: 30px;
    margin: 0 auto;
    opacity: 0.2;
    background-color: #7a1216;
    transition: height 1.5s;
    transition-timing-function: ease-in-out;
  }
  .bar-label {
    text-align: center;
    padding-top: 12px;
    height: 60px;
    span {
      font-size: 0.85rem;
      color: $gray-400;
    }
  }
}
</style>
